import { Box, Button, Typography } from "@mui/material";
import useAPI from "../api/hooks/useAPI";
import useColors from "../api/hooks/useColors";
import SvgToIcon from "../icons/SvgToIcon";
import { icons } from "../scenes/stack/environment/icons/iconExport";
import { PageDisplayMode } from "../utils/constants";

const DisplayMode = ({
  displayMode,
  setDisplayMode,
  options = [
    {
      value: PageDisplayMode.GRID,
      icon: "CardIcon",
      label: "Full Overview",
    },
    {
      value: PageDisplayMode.TABLE,
      icon: "TableIcon",
      label: "Scenarios Focus",
    },
  ],
  containerStyle = {},
}) => {
  const colors = useColors();
  const { trackEvent } = useAPI();
  const buttonStyles = {
    selected: {
      backgroundColor: colors.primary_8percent,
      color: colors.primary_main,
      textTransform: "none",
      borderRadius: "8px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      gap: 1,
      minWidth: "auto",
      padding: "4px 12px",
      "&:hover": {
        backgroundColor: colors.primary_16percent,
      },
    },
    unselected: {
      backgroundColor: "transparent",
      color: colors.text_primary,
      textTransform: "none",
      borderRadius: "8px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      gap: 1,
      minWidth: "auto",
      padding: "4px 12px",
      "&:hover": {
        backgroundColor: colors.grey_8percent,
      },
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        border: "1px solid " + colors.grey_8percent,
        borderRadius: "8px",
        alignItems: "center",
        gap: "4px",
        padding: "4px",
        height: "32px",
        backgroundColor: colors.common_white,
        width: "fit-content",
        ...containerStyle,
      }}
    >
      {options.map((option) => (
        <Button
          key={option.value}
          onClick={() => {
            setDisplayMode(option.value);
            trackEvent(`User changed display mode to ${option.value}`);
          }}
          sx={
            displayMode === option.value
              ? buttonStyles.selected
              : buttonStyles.unselected
          }
          disableElevation
          disableRipple={false}
        >
          <SvgToIcon
            IconLogo={icons[option.icon]}
            style={{
              color:
                displayMode === option.value
                  ? colors.primary_main
                  : colors.text_primary,
              width: 16,
              height: 16,
            }}
          />
          <Typography
            variant={displayMode === option.value ? "overline" : "caption"}
            sx={{
              whiteSpace: "nowrap",
            }}
          >
            {option.label}
          </Typography>
        </Button>
      ))}
    </Box>
  );
};

export default DisplayMode;
